/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import { Box } from '@mui/material'
import { country } from 'store/AIMetricOT/reducerSlice'
import { useActions, useAppSelector } from 'hooks'
import { getCountryNameFromCountryLongCode } from 'utils'
import { DownloadType } from 'types'
import { DOWNLOAD_FILE_NAME } from 'constant'
import DownloadImages from 'components/common/Download/DownloadImages'
import { useImageDownload } from 'components/common/Download/useImageDownload'
import ChartHeader from 'components/common/ChartHeader/ChartHeader'
import NationalBarChart from 'components/common/NationalBarChart/NationalBarChart'

export default function NationalVibrancyRankingChart() {
  const countryLongCode = useAppSelector(country)
  const countryData = useAppSelector(({ vibrancy }) => vibrancy.countryData)
  const countryName = getCountryNameFromCountryLongCode(countryData, countryLongCode)
  const { yearFilter } = useAppSelector(({ vibrancy }) => vibrancy.configuration)
  const popUpRef = useRef<HTMLDivElement>(null)
  // Download images
  const fileNameDownload = DOWNLOAD_FILE_NAME.nationalAiVibrancyRankingBar
  const { setShowDwnLoader } = useActions()
  const [clickDownload, setClickDownload] = useState<DownloadType>(null)
  const { handleCallDownload, divRef } = useImageDownload()
  const handleDivDownload = (type: DownloadType) => {
    setShowDwnLoader(true)
    setClickDownload(type)
  }
  useEffect(() => {
    if (clickDownload) {
      handleCallDownload(clickDownload, {
        fileName: fileNameDownload,
        orientation: 'portrait',
        isSquareDownload: true,
      })
      setClickDownload(null)
    }
  }, [clickDownload])

  const yearSource = new Date().getFullYear()
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%', position: 'relative' }}>
      <DownloadImages
        handleDownPNG={() => handleDivDownload('png')}
        handleDownJPG={() => handleDivDownload('jpg')}
        handleDownPDF={() => handleDivDownload('pdf')}
      />
      <Box sx={{ padding: '24px', height: '100%' }}>
        <Box ref={popUpRef}>
          <ChartHeader
            header1={`${yearFilter.currentYear} Global AI Vibrancy Ranking: ${countryName}`}
            header2={`Source: ${yearSource} AI Index`}
          />
          <NationalBarChart ref={popUpRef} />
        </Box>
      </Box>
      <Box
        className='is4Downloaded'
        sx={{ zIndex: -1, position: 'absolute', padding: '24px', minWidth: '970px' }}
        ref={divRef}
      >
        <ChartHeader
          header1={`${yearFilter.currentYear} Global AI Vibrancy Ranking: ${countryName}`}
          header2={`Source: ${yearSource} AI Index`}
        />
        <NationalBarChart is4Downloaded />
      </Box>
    </Box>
  )
}
